import {useEffect, useState, useRef, useMemo} from "react";
import {useParams, useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Form from "react-bootstrap/Form";
// -
import NavBreadcrum from "components/NavBreadcrum";
import {SwalAlertClass} from "core/swalClass";
import axiApi from "ApiCaller";
import {DeviceServerModel} from "site-apps/devices/networks/DeviceNetworkModels";
import ManagerMQTTForm from "./modes/forms/ManagerMQTTForm";
import navs from "../navs";
import {formRefToJson} from "core/utils/formularies";
import FormButton from "components/buttons/FormButton";
import useCustomTranslation from "core/customTranslation";
import translations from "./translations";

const FormMQTTBasic = () => {
    const {t: _Tt} = useTranslation("tags");
    const {t: _Tf} = useTranslation("forms");
    const {t: _Tr} = useTranslation("routes");
    const {t: _TC} = useCustomTranslation(translations);

    document.title = _Tr("labels.mqtt-config");
    const navigate = useNavigate();
    const Alert = new SwalAlertClass({confirmButtonText: _Tf("labels.accept")});

    const bread = useMemo(() =>
        [
            {name: _Tr("labels.advanced"), url: "/advanced/", current: false},
            {name: _Tr("labels.mqtt"), url: "/advanced/mqtt/", current: false},
            {name: _Tr("labels.mqtt-config"), current: true}
        ], [_Tr]);
    const formRef = useRef(null);

    const [item, setItem] = useState({...DeviceServerModel});
    const [models, setModels] = useState([]);
    const modes = useRef({});

    const {id} = useParams();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(false)
        if (Number.isInteger(parseInt(id))){
             axiApi.get(`/api/devices/network/mqtt/${id}/`)
                .then((r) => {
                    if (r.data.status) {
                        setItem({...r.data.item});
                        setModels([...r.data.models]);
                        let modes_ = r.data.modes;
                        modes_[r.data.item.model].has = r.data.item.has;
                        modes_[r.data.item.model].values = r.data.item.values;
                        modes.current = {...modes_};
                    }
                })
        } else {
            axiApi.get("/api/devices/network/mqtts/modes/basic/").then((resp) => {
                if (resp.data.status) {
                    modes.current = {...resp.data.modes};
                    setModels([...resp.data.models]);
                    let item_ = {...DeviceServerModel};
                    item_.model = resp.data.models[0];
                    item_.has = {...resp.data.modes.has};
                    item_.values = {...resp.data.modes.values};
                    setItem(item_);
                }
            })
        }
    }, [id]);

    const onSubmit = (e) => {
        if (!formRef.current.reportValidity()) {
            return; // Si no es válido, no continuar
        }
        setIsLoading(true);
        let data = formRefToJson(formRef.current);

        axiApi.post("/api/devices/network/mqtt/", data)
            .then((r) => {
                if (r.data.status) {
                    Alert.success(_Tt("messages.title"), _Tt("messages.success"))
                        .then(() => {
                            navigate("/advanced/mqtt/")
                        });
                }
            }).finally(setIsLoading(false))
    }

    const changeModel = (e) => {
        let model_ = e.target.value;
        modes.current[item.model].has = {...item.has};
        modes.current[item.model].values = {...item.values};
        setItem({...item, model: model_});
    }

    return (<>
        <NavBreadcrum navs={navs} bread={bread}/>
        <div className="preview-canvas mt-1">
            <div className="preview-icon">
                <FontAwesomeIcon icon="ethernet"/>
            </div>
            <div className="preview-title d-flex align-items-center ms-3">
                <h3>{item.name ? `${_TC("basic")}: ${item.name}` : _TC("create.title.basic")}</h3>
            </div>
        </div>
        <Form onSubmit={(e) => {
            e.preventDefault()
        }} ref={formRef}>
            <input type="hidden" name="id" defaultValue={item.id}/>
            <input type="hidden" name="type" defaultValue="b"/>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-1 col-md-2">
                        <div className="text-md-end mt-2">
                            <label htmlFor="name" className="form-label">
                                {_Tt("common.name")}
                            </label>
                        </div>
                    </div>
                    <div className="col-lg-5 col-12 d-flex align-items-center">
                        <input
                            type="text"
                            id="name"
                            name="name"
                            className="form-control"
                            required={true}
                            defaultValue={item.name}
                        />
                    </div>
                    <div className="col-lg-1 col-md-2">
                        <div className="text-md-end mt-2">
                            <label htmlFor="model" className="form-label">{_Tt("common.model")}</label>
                        </div>
                    </div>
                    <div className="col-lg-3 col-12 d-flex align-items-center">
                        <Form.Select className="mb-2"
                                     id="model" name="model"
                                     value={item.model}
                                     style={{maxWidth: "120px"}}
                                     onChange={changeModel}
                        >
                            {
                                models.map((model, index) => (
                                    <option key={index} value={model}>{model}</option>
                                ))
                            }
                        </Form.Select>
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-lg-1 col-md-3">
                        <div className="text-md-end mt-2">
                            <label htmlFor="description" className="form-label">
                                {_Tt("common.description")}
                            </label>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-8 col-12 d-flex align-items-center">
                        <textarea
                            id="description"
                            name="description"
                            className="form-control"
                            defaultValue={item.description}
                        />
                    </div>
                </div>
                <div className="row mt-3 mb-3">
                    <ManagerMQTTForm item={item} model={item.model}/>
                </div>
            </div>

            <div className="fixed-bottom d-flex justify-content-end p-3 bg-light">
                <button
                    type="button"
                    className="btn btn-secondary me-4"
                    onClick={() => navigate("/advanced/mqtt/")}
                >
                    {_Tf("labels.cancel")}
                </button>
                <FormButton
                    type="button"
                    onClick={onSubmit}
                    className="btn btn-primary"
                    isProcessing={isLoading}
                >
                    {_Tf("labels.save")}
                </FormButton>
            </div>
        </Form>
    </>);
}

export default FormMQTTBasic;